<template>
    <div>
        <template v-if="cta">
            <button href="#"
                class="btn btn-primary d-flex flex-nowrap align-items-center justify-content-center"
                :style="`background-color: ${cta};`"
                :disabled="status.downloading"
                @click.prevent="manageAction">

                <span class="pe-3" v-html="cta"></span>

                <template v-if="status.downloading">
                    <div class="spinner-border spinner-border-sm" role="status" style="font-size: 12px;">
                        <span class="sr-only">Loading...</span>
                    </div>
                </template>

                <img src="https://asurcloudrunprod-16905.kxcdn.com/public-assets/right-arrow-icon" class='arrow-icon' width="18" height="18" v-else/>
            </button>
        </template>

        <LoginModal ref="loginModal" :cta="cta" @sendEmail="sendEmail"/>
    </div>
</template>
<script>
import LoginModal from './LoginModal.vue';

export default {
    props: {
        cta: String,
        promotionSlug: String,
        downloadThanksText: String
    },
    components: { LoginModal },
    data: () => ({
        status: {
            downloading: false
        },
        hasSentEmail: false
    }),
    methods: {
        manageAction() {
            if (this.$contact || window.contact) { this.sendEmail(); return; }

            this.openLoginModal();
        },
        sendEmail() {
            if (this.hasSentEmail) {
                const reclamed = this.$locale == 'es' ? 'Ya has reclamado este cupón.' : 'You have already claimed this coupon.';
                this.$swal('', reclamed, 'warning');
                return;
            }

            if (this.status.downloading) return;

            this.status.downloading = true;
            let contact = this.$contact || window.contact;
            let message = this.downloadThanksText;

            this.$axios.post(`/api/v1/promotions/${this.promotionSlug}/exchange?locale=${this.$locale}`, {
                data: {
                    email: contact ? contact.email : null
                }
            }).then(() => {
                if (!message) {
                    message = this.$locale == 'es' ? 'Tu código se ha enviado a tu correo electrónico.' : 'Your code has been sent to your email.';
                }

                this.$swal('',message,'success');
                this.hasSentEmail = true;
            }).catch(() => {
                const error = this.$locale == 'es' ? 'El cupón ya no es válido' : 'The coupon is no longer valid';
                this.$swal('Oops..', error, 'error');
            }).finally(() => {
                this.status.downloading = false;
            });
        },
        openLoginModal() {
            this.$refs.loginModal.show();
        }
    }
}
</script>